<template>
  <div class="Kanit" style="color: black">
    <div class="text-center Kanit" style="font-size: 25px; font-weight: 600">
      งานรอยืนยันการเริ่ม
    </div>
    <div class="pt-9">
      <v-card v-for="job in jobs" :key="job.orderid" outlined class="pa-2 pb-4">
        <div style="font-weight: 900; font-size: 11px; margin-bottom: 15px">
          JobID : #{{ job.orderid }} ลูกค้า {{ job.customer_name }}
        </div>
        <div class="px-3">
          <div style="display: flex; flex-direction: row">
            <div>
              <img
                style="height: 60px; width: 80px"
                :src="job.customer_profile_pic"
              />
            </div>
            <div style="align-self: center; margin-left: 20px; font-size: 10px">
              ผู้จ้าง: {{ job.customer_name }}
            </div>
          </div>
          <div style="font-size: 10px; font-weight: bold">
            <div style="font-size: 13px">รายละเอียดงาน</div>
            <div style="line-height: 15px">
              ประเภทงาน: {{ job.work_type }}<br />
              พื้นที่การทาสี: {{ job.work_area }} ตรม.<br />
              สถานที่ปฏิบัติงาน: {{ job.customer_address }}
            </div>
          </div>
        </div>
        <div class="mt-3" style="color: #08088a; font-size: 11px">
          สถานะแจ้งการเริ่มงาน :
          <span v-if="job.status == 'รอยืนยันเริ่มงาน'" style="color: green"
            >รอยืนยัน</span
          >
          <span v-else style="color: red">ถูกยกเลิก</span>
        </div>
        <div class="px-4">
          <v-btn
            @click="sendConfirmAgain(job.orderid)"
            class="mt-3"
            small
            color="#4695da"
            outlined
            block
            rounded
            >แจ้งเริ่มงานอีกครั้ง</v-btn
          >
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
  props: ["value"],
  data() {
    return {
      input: {
        remark: "",
      },
      saveloading: false,
      cancelModal: false,
      loading: "",
      currentCancel: "",
    };
  },
  computed: {
    jobs() {
      return this.value.orderlist.filter(
        (el) => el.status == "รอยืนยันเริ่มงาน"
      );
    },
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
    moment() {
      return moment;
    },
  },
  methods: {
    sendConfirmAgain(orderid) {
      var vm = this;
      this.$swal.fire({
        text: "ต้องการแจ้งเริ่มงานอีกครั้ง?",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        showLoaderOnConfirm: true,
        cancelButtonText: "ยกเลิก",
        preConfirm: () => {
          return new Promise((resolve, reject) => {
            vm.loading = orderid;
            var body = {
              userid: this.$store.state.userid,
              apptype: this.query.apptype,
              pageid: vm.query.pageid,
              orderid,
            };
            axios
              .post(
                "https://communitybotbyzwizai.herokuapp.com/toapainterreplyorderagain",
                body,
                {
                  headers: {
                    AUTHORIZATION: "Bearer xxx xxx",
                  },
                }
              )
              .then((response) => {
                if (response.data.responsecode == 200) {
                  vm.$swal.fire({
                    icon: "success",
                    text: "สำเร็จ",
                  });
                }
                vm.loading = "";
                resolve();
              });
          });
        },
      });
    },
  },
};
</script>
